module.exports = __webpack_public_path__ + "img/start_at_the_end.e63bad80.jpg";